import { Col, Row } from "react-bootstrap"
import { Link } from "react-router-dom"
import FormPatient from "../../components/patient/FormPatient";
import { IoIosCloseCircle } from "react-icons/io";
import useQuery from "../../hook/useQuery";
import { useContext, useState } from "react";
import { withTranslation } from "react-i18next";
import useCompanyType from "../../hook/useCompanyType";
import FormPatientColombia from "../../components/patient/FormPatientColombia";
import { isDoctor } from "../../utils/isDoctor";
import { authContext } from "../../context/AuthContext";
import { isConsultorio } from "../../utils/isConsultorio";

function AddPatient({t}){
    const {auth} = useContext(authContext)
    const query = useQuery()
    const id = query.get('id')
    const [edit, setEdit] = useState(true)
    const companyType = useCompanyType()

    return (
        <>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">{`${id ? t('editar') : t('agregar')} ${t('paciente')}`}</h2>
                </Col>
                <Col xs="12" md="4" className="text-right">
                    <Link to={(isDoctor(auth.data.role) || isConsultorio(auth.data.role)) ? "/admin/doctors/patients" : "/admin/patients"}><IoIosCloseCircle className="cancel-btn"/></Link>                    
                </Col>
            </Row>
            {
                companyType === "colombia" ? 
                <FormPatientColombia id={id} edit={edit} isNew={true} /> :
                <FormPatient id={id} edit={edit} isNew={true}/>            
            }            
        </>
    )
}

export default withTranslation()(AddPatient)